import { render, staticRenderFns } from "./OrganizationDashboard.vue?vue&type=template&id=3cbddbb5&scoped=true"
import script from "./OrganizationDashboard.vue?vue&type=script&lang=js"
export * from "./OrganizationDashboard.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDashboard.vue?vue&type=style&index=0&id=3cbddbb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbddbb5",
  null
  
)

export default component.exports